<template>
  <el-card class='stats-card' >
    <div slot="header" class="clearfix">
      <span>Stats</span>
      <span v-if="$store.getters.stopped" class="stopwarn">Not running</span>
    </div>
    <el-row>
      <el-col :span="6" class="kv-key"> Project name</el-col>
      <el-col :span="18" class="kv-value"> {{$store.state.name}} </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key"> Start time </el-col>
      <el-col :span="18" class="kv-value"> {{getStartTime}} </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key">Expected end time</el-col>
      <el-col :span="18" class="kv-value"> {{getExpectedEndTime}} </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key"> Chips tested </el-col>
      <el-col :span="18" class="kv-value"> {{getChipTested}} </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key">Total retries done</el-col>
      <el-col :span="18" class="kv-value"> {{getTotalRetries}} </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key"> Overall progress </el-col>
      <el-col :span="18">
        <el-progress :text-inside="true" :stroke-width="18" :percentage="getOverallProgress"></el-progress>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key"> Average chip time </el-col>
      <el-col :span="18" class="kv-value"> {{getAverageChipTime}} </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key"> Chips accepted </el-col>
      <el-col :span="18" class="kv-value"> {{$store.state.counters.ok}} ({{getOKPercentage}}%) </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key">Total Chips rejected</el-col>
      <el-col :span="18" class="kv-value">{{getRejectedCurrentSum}}</el-col>
    </el-row>
    <el-row v-for="(reject, ir) in $store.state.counters.rejects" :key="ir">
      <el-col :span="6" class="kv-key"> Chips rejected for sink {{ir}}</el-col>
      <el-col :span="18">
        <div style="margin-bottom:5px">{{reject.current}} for {{reject.id}} errors out for {{reject.total}} available positions</div>
        <el-progress status="exception" :text-inside="true" :stroke-width="18" :percentage="Math.round((reject.current/reject.total)*100)"></el-progress>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class="kv-key">Last update</el-col>
      <el-col :span="18" class="kv-value">{{getLastUpdate}}</el-col>
    </el-row>
  </el-card>
</template>

<script>
  import { DateTime } from 'luxon'
  var DTFMT = Object.assign({ timeZoneName: 'short' }, DateTime.DATETIME_SHORT_WITH_SECONDS)

  export default {
    name: 'stats-card',
    computed: {
      retriesTableData() {
        var data = []
        for( var ib = 0; ib < this.$store.state.boards.length; ib++ ){
          var b = this.$store.state.boards[ib]
          for( var isk = 0; isk < b.sockets.length; isk++ ){
            data.push({'board': ib, 'socket': isk, 'retries': b.sockets[isk].retries})
          }
        }
        return data
      },
      getTotalRetries() {
        var rt = 0
        for( var ib in this.$store.state.boards ){
          var b = this.$store.state.boards[ib]
          for( var isk in b.sockets ){
            rt += b.sockets[isk].retries
          }
        }
        return rt
      },
      getStartTime() {
        return this.$store.state.start_time.toLocaleString(DTFMT)
      },
      getOverallProgress() {
        var ps = this.$store.state.counters
        if(ps.source.total === 0 ) {
          return 0
        }
        return Math.round( ( ps.source.current ) / ( ps.source.total ) * 100 )
      },
      getChipTested() {
        var ps = this.$store.state.counters
        var ret = '' + ps.source.current + ' / ' + ps.source.total
        if (this.$store.state.start_chip > 0) {
          ret = ret + ' (started at chip ' + this.$store.state.start_chip + ')'
        }
        return ret
      },
      getRejectOccupancy() {
        return this.$store.counters.rejects.map( r => {
          if (r.current === 0) {
            return 0
          }
          return Math.round( r.current / r.total * 100 )
        })
      },
      getOKPercentage() {
        var ps = this.$store.state.counters
        var total = ps.ok
        for( var ir in ps.rejects ){
          total += ps.rejects[ir].current
        }
        if (total === 0) {
          return 0
        }
        return Math.round( ps.ok * 100 / total )
      },
      getRejectedCurrentSum() {
        var ps = this.$store.state.counters
        var rejected = 0
        for( var ir in ps.rejects ){
          rejected += ps.rejects[ir].current
        }
        return rejected
      },
      getRejectedTotalSum() {
        var ps = this.$store.state.counters
        var rejected = 0
        for( var ir in ps.rejects ){
          rejected += ps.rejects[ir].total
        }
        return rejected
      },
      getLastUpdate() {
        var suf = ''
        if( this.$store.getters.stopped ) {
          suf = ' (stopped)'
        }
        return this.$store.state.heartbeat.toLocaleString(DTFMT) + suf
      },
      getChipsDone() {
        var ps = this.$store.state.counters
        var cd = ps.source.current - this.$store.state.start_chip
        this.$store.state.boards.forEach((b) => {
          b.sockets.forEach(s => {
            if(b.state !== 'empty') {
              cd -= 1
            }
          })
        })
        return cd
      },
      getExpectedEndTime() {
        var ps = this.$store.state.counters
        var chips_tested = this.getChipsDone
        if (chips_tested < 5 ) {
          return 'Can\'t calculate expected end time until some chips have been tested'
        }
        var elapsed_secs = Math.round( this.$store.state.heartbeat.diff(this.$store.state.start_time) / 1000 )
        var secs_per_chip = elapsed_secs / chips_tested
        var chips_left = ps.source.total - ps.source.current
        var secs_left = Math.round( ( secs_per_chip * chips_left ) / 600 ) * 600
        var endTime = DateTime.local().plus({ seconds: secs_left })
        var days_left = Math.floor( secs_left / 86400 )
        var hours_left = Math.floor( ( secs_left - ( days_left * 86400 ) ) / 3600 )
        var mins_left = Math.ceil( ( secs_left - (hours_left * 3600 + days_left * 86400) ) / 60 )
        return endTime.toLocaleString(DTFMT) + ' (' + days_left + 'd ' + hours_left + 'h ' + mins_left + 'm left)'
      },
      getAverageChipTime() {
        var chips_tested = this.getChipsDone
        console.log('Tested in run', chips_tested)
        if (chips_tested < 5 ) {
          return 'Can\'t calculate expected end time until some chips have been tested'
        }
        var elapsed_secs = Math.round( this.$store.state.heartbeat.diff(this.$store.state.start_time) / 1000 )
        var secs_per_chip = elapsed_secs / chips_tested
        var mins_left = Math.floor( secs_per_chip / 60.0 )
        var secs_left = Math.round( secs_per_chip - ( mins_left * 60 ) )
        return '' + mins_left + 'm ' + secs_left + 's'
      },
      getImageData() {
        return 'data:image/jpg;base64,' + this.$store.state.photo.data
      }
    }
  }
</script>

<style scoped>
  #top {
    margin-top: 10px;
    height: 100%;
  }
  .el-card {
    margin: 10px;
    float: left;
  }
  .stats-card {
    width: 800px;
  }
  .el-col {
    padding: 5px;
  }
  .kv-key {
    text-align: right;
  }
  .kv-value {
    text-align: left;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
  .stopwarn {
    color: #F31;
    float: right;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// stats-card.vue?1bdb41a3